import type { ContainerType } from "~/container";
import type { IApi } from "~/interfaces/IApi";
import type { IRespondingAgencyService } from "@saif-reporting/domain/interfaces/services/IRespondingAgencyService.js";
import type { RespondingAgencyDto } from "@saif-reporting/domain/dtos/models/RespondingAgencyDto.js";

export class RespondingAgencyService implements IRespondingAgencyService {
  private readonly api: IApi;
  constructor({ baseApi }: ContainerType) {
    this.api = baseApi;
  }

  async getList(): Promise<RespondingAgencyDto[]> {
    return await this.api.$fetch<RespondingAgencyDto[]>("/responding-agencies");
  }
}
